import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/staff-revenue";

export const searchRevenuePayment = (obj) =>
  axios.post(API_PATH + "/search-by-page", obj);

export const updateListStaffRevenue = (obj) =>
  axios.post(
    API_PATH + "/update-list-staff-revenue-by-voucher-item",
    obj
  );

export const exportExcelDistributionGeneralReport = (obj) => {
  let url = API_PATH + "/export-excel-distribution-general-report";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

